import createModule from "../createModule"
import { Creators as DialogCreators } from "modules/dialog/model"
import view from "./view"
import { getAccount, getTopicId, getModels, getModel, getFavoriteUpdating, getModelAvailability, getTopicPermission, getPortfolioInfo, getPortfolioDates } from "./selectors"
import { getTopicWithMeta } from "./selectors/menu"
import { Creators } from "./model"
import { size } from "lodash"
import { classificationsQuery } from "helpers/classification"
import withUrlParams from "hocs/withUrlParams"
import withOutletContext from "hocs/withOutletContext"
import { MODEL_METADATA_QUERY } from "resources/models"
import { CONTENT_SETS_METADATA_QUERY } from "resources/content-sets"

export default withUrlParams(withOutletContext(createModule({
  view,
  externalProps: (state, props) => ({
    accountId: state.global.selected.accountId,
    account: getAccount(state),
    topicId: getTopicId(props),
    models: getModels(state),
    portfolioInfo: getPortfolioInfo(state),
    modelId: getModel(state),
  }),
  required: ["account"],
  data: [{
    resource: "modelsAvailability",
    as: null,
    url: () => ({
      id: "models",
      query: "query { models { id, name, availability { currentDate, factorsStartDate, securitiesStartDate } } }",
    }),
  }, {
    resource: "topic",
    url: ({ topicId }) => ({
      id: `topic-${topicId}`,
      query: `query ($topicId: IdOrShortIdOrAlias!) {
        resource(id: $topicId type: RESEARCH_TOPIC){
          id,
          name,
          description,
          lastUpdated: updatedAt,
          ... on ResearchTopicResource {
            selectedDate
            referenceInstrument {
              type
              securityId { ticker mic country internalId }
              portfolioId
            }
          }
          permissionLevel
        }
      }`,
      variables: { topicId },
    }),
  }, {
    resource: "instrumentPortfolioDates",
    url: ({ account, portfolioInfo }) => {
      if (!portfolioInfo) { return null }
      return `/api/${account}/p/${portfolioInfo.id}`
    },
  }, {
    resource: "topicExperiments",
    url: ({ account, topicId }) => `/api/${account}/t/${topicId}/experiments`,
  }, {
    resource: "userFavoriteResources",
    url: ({ accountId }) => ({
      id: `userFavoriteResources-${accountId}`,
      url: "/api/users/me/preferences",
      payload: {
        items: [{ type: "favoriteResources", accountId }],
      },
    }),
  }, {
    resource: "portfolios",
    as: null,
    url: ({ account }) => `/api/${account}/portfolios`,
  }, {
    resource: "researchTopicRootPreferences",
    url: ({ accountId, models }) => {
      if (size(models) === 0) {
        return null
      }

      return ({
        id: `researchTopicRootPreferences-${accountId}`,
        url: "/api/users/me/preferences",
        payload: {
          items: [
            {
              type: "researchTopicLastModelUsed",
              accountId,
            },
          ],
        },
      })
    },
  }, {
    ...CONTENT_SETS_METADATA_QUERY,
    as: null,
  }, {
    resource: "classifications",
    as: null,
    url: () => ({
      id: "classifications",
      query: classificationsQuery,
    }),
  }, MODEL_METADATA_QUERY],
  mapStateToProps: (state) => ({
    topic: getTopicWithMeta(state),
    modelAvailability: getModelAvailability(state),
    favoriteUpdating: getFavoriteUpdating(state),
    permissionLevel: getTopicPermission(state),
    portfolioDates: getPortfolioDates(state),
  }),
  actions: {
    ...Creators,
    openDialog: DialogCreators.open,
  },
})))
